var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, computed, makeObservable } from 'mobx';
import { Actor } from '../actor/Actor';
import { StageTypeInfo } from './modules/StageTypeInfo';
import { StageMountedActors } from './modules/StageMountedActors';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { StageScene } from './modules/StageScene';
import { runtime } from '../runtime/Runtime';
import { deserialize } from '../../utils/serializr/core/deserialize';
import { StageDraftLayout } from './modules/StageDraftLayout';
import { StageInnerMeasure } from './modules/StageInnerMeasure';
import { StageMountedAspects } from './modules/StageMountedAspects';
import { StageMountedAttachedTraits } from './modules/StageMountedAttachedTraits';
import { StageEmerge } from './modules/emerge/StageEmerge';
export class Stage extends Actor {
    itemOnStage;
    get isStageFoggy() {
        if (!this.app.question)
            return false;
        if (!this.app.question.answeringState.isInFeedbackState)
            return false;
        if (this.app.question.answeringFeedback.remainingFeedbackTime > 300)
            return false;
        return true;
    }
    type = 'stage';
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get stageTypeInfo() {
        return new StageTypeInfo(this);
    }
    get stageInnerMeasure() {
        return new StageInnerMeasure(this);
    }
    get stageMountedAspects() {
        return new StageMountedAspects(this);
    }
    get stageMountedActors() {
        return new StageMountedActors(this);
    }
    get stageAttachedTraits() {
        return new StageMountedAttachedTraits(this);
    }
    get stageScene() {
        return new StageScene(this);
    }
    get stageEmerge() {
        return new StageEmerge(this);
    }
    get draftLayout() {
        return new StageDraftLayout(this);
    }
    get stageEdit() {
        return new runtime.solidPackages.Edit.classes.StageEdit(this);
    }
    get app() {
        return this.parent;
    }
    static fromSerialized(ser = {}) {
        return deserialize(Stage, ser);
    }
    static get serializeInfo() {
        return {
            extends: Actor.serializeInfo,
            props: {},
        };
    }
}
__decorate([
    observable.ref
], Stage.prototype, "itemOnStage", void 0);
__decorate([
    computed
], Stage.prototype, "isStageFoggy", null);
__decorate([
    memoize
], Stage.prototype, "stageTypeInfo", null);
__decorate([
    memoize
], Stage.prototype, "stageInnerMeasure", null);
__decorate([
    memoize
], Stage.prototype, "stageMountedAspects", null);
__decorate([
    memoize
], Stage.prototype, "stageMountedActors", null);
__decorate([
    memoize
], Stage.prototype, "stageAttachedTraits", null);
__decorate([
    memoize
], Stage.prototype, "stageScene", null);
__decorate([
    memoize
], Stage.prototype, "stageEmerge", null);
__decorate([
    memoize
], Stage.prototype, "draftLayout", null);
__decorate([
    memoize
], Stage.prototype, "stageEdit", null);
__decorate([
    memoize
], Stage, "serializeInfo", null);
